<template>
  <div class="text-center">
    <v-snackbar
      v-model="snackbar"
      color="var(--quomi-blue)"
      elevation="24"
      :timeout="timeout"
      transition="slide-y-reverse-transition"
      :multi-line="multiLine"
      :top="!$mq.isDesktop()"
      :class="{'mt-3': !$mq.isDesktop()}"
    >
      <span class="text-bold">{{ text }}</span>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    data: () => ({
      multiLine: false,
      snackbar: false,
      text: `Il prodotto è stato aggiunto al carrello!`,
      timeout: 2000,
    }),
    created() {
			window.addEventListener('trigger-snackbar', () => {
          return this.snackbar = true
        });
    },
    destroyed() {
      window.removeEventListener('trigger-snackbar', () => {return this.snackbar = true});
    }
  }
</script>

<style>
  .v-snack__content {
    text-align: center !important;
  }
  .v-snack__wrapper {
    bottom: 10px;
  }
</style>